//      

// A scroll event will only be triggered when there is a value of at least 1px change
export default 1;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/auto-scroller/fluid-scroller/get-scroll/get-scroll-on-axis/min-scroll.js